export const sessionService = {
  logout: () => null,
};
